import { motion } from "framer-motion";
import React from "react";

const Banner = () => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.5, type: "spring", stiffness: 300 }}
      className="banner"
    >
      <p>
        📣 [Limited time offer] ⌛ Register your business with us now and get a
        free 3-month premium subscription.{" "}
        <a href="#business" className="banner-link">
          Join us now
        </a>
      </p>
    </motion.div>
  );
};

export default Banner;
